// eslint-disable-next-line import/prefer-default-export
export const makeRequest = (
  url, payload
) => fetch(url, {
  body: payload,
  credentials: 'include',
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  },
  method: 'POST',
}).then((response) => {
  // overt error: bad HTTP response
  if (!response.ok) {
    return response.text()
      .then(
        text => Promise.reject(new Error(`STATUS ${response.status}: ${text}`)),
        /* istanbul ignore next */
        error => Promise.reject(error)
      );
  }
  return response.text();
})
  .then((text) => {
    if (text === '') {
      return {};
    }
    try {
      return JSON.parse(text);
    } catch (err) { /* istanbul ignore next */ console.log(`Response: ${text}`); }
    return text;
  })
// service-level error reported in the response body
  .then((response) => {
    if (response.status && response.status >= 400) {
      const error = response.error
        ? new Error(response.error)
        : new Error(JSON.stringify(response));
      error.status = response.status;
      return Promise.reject(error);
    }
    return response;
  });
